import { createSelector } from 'reselect'
import ApiModel from '../ApiModel'
import { Connection } from './types'
import { ApiState } from '../types'
import { registerApiCustomReducer } from '../reducers'

const MODEL = new ApiModel('INDICATOR_SET', 'api/v1/indicator_sets')
const ACTIONS = {
  UPDATE_FLAGS: 'UPDATE_FLAGS',
}

type modelState = Record<string, boolean>

registerApiCustomReducer<modelState>('indicator_set', (state = {}, action) => {
  if (MODEL.isModelCustomAction(action) && action.customType === ACTIONS.UPDATE_FLAGS) {
    return { ...state, ...action.payload }
  }

  return state
})

export const updateIndicatorSetCache = (flags: modelState) => {
  MODEL.dispatchCustomAction(flags, ACTIONS.UPDATE_FLAGS)
}

export const IndicatorSet: {
  connection: Connection<{ indicatorSet: modelState }>,
} = {
  connection: {
    load: ({ indicatorSet }) => indicatorSet == null && void MODEL.read(),

    isLoaded: ({ indicatorSet }) => indicatorSet != null,

    selector: createSelector(
      [state => (state.api as ApiState).indicator_set as modelState],
      indicatorSet => ({ indicatorSet }),
    ),
  },
}
